// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3wYA8","footer":"ReportModalFilter_footer__WdmZ6"};